import { useState, useEffect } from "react";
import { Phone, Menu, X } from "lucide-react";

const NAV_LINKS = [
    { href: "#servicii", label: "Servicii", testid: "nav-services" },
    { href: "#rca", label: "Calculator RCA", testid: "nav-rca" },
    { href: "#proces", label: "Cum lucrăm", testid: "nav-process" },
    { href: "#despre", label: "Despre noi", testid: "nav-about" },
    { href: "#faq", label: "Întrebări", testid: "nav-faq" },
    { href: "#contact", label: "Contact", testid: "nav-contact" },
];

export default function Header({ onCtaClick }) {
    const [open, setOpen] = useState(false);

    // Close mobile menu when window resizes to desktop
    useEffect(() => {
        const onResize = () => { if (window.innerWidth >= 1024) setOpen(false); };
        window.addEventListener("resize", onResize);
        return () => window.removeEventListener("resize", onResize);
    }, []);

    const handleCta = () => { setOpen(false); onCtaClick?.(); };

    return (
        <header
            data-testid="site-header"
            className="fixed top-0 inset-x-0 z-40 bg-[#fcfbf8] border-b border-[#0d3d2e]/10"
        >
            <div className="max-w-7xl mx-auto px-6 lg:px-10 h-24 flex items-center justify-between">
                <a href="#top" className="flex items-center gap-3" data-testid="header-logo" onClick={() => setOpen(false)}>
                    <img
                        src="/logo.png"
                        alt="OPTIM SAFE — Asistentul tău în brokeraj"
                        className="h-12 lg:h-14 w-auto object-contain"
                    />
                </a>

                {/* Desktop nav */}
                <nav className="hidden lg:flex items-center gap-7 text-base font-semibold text-[#0d3d2e]/85">
                    {NAV_LINKS.map((l) => (
                        <a key={l.href} href={l.href} className="hover:text-[#0d3d2e] transition-colors" data-testid={l.testid}>
                            {l.label}
                        </a>
                    ))}
                </nav>

                <div className="flex items-center gap-2">
                    <a
                        href="tel:0745643348"
                        data-testid="header-call-btn"
                        className="hidden sm:inline-flex items-center gap-2 text-sm text-[#0d3d2e] hover:text-[#0d3d2e]/70 transition-colors"
                    >
                        <Phone className="h-4 w-4" strokeWidth={1.5} />
                        0745 643 348
                    </a>
                    <button
                        onClick={handleCta}
                        data-testid="header-cta-btn"
                        className="hidden sm:inline-flex items-center rounded-full bg-[#0d3d2e] text-[#fcfbf8] px-4 py-2 text-sm font-medium hover:bg-[#0d3d2e]/90 transition-all hover:translate-y-[-1px]"
                    >
                        Cere ofertă
                    </button>
                    {/* Mobile hamburger */}
                    <button
                        onClick={() => setOpen((s) => !s)}
                        aria-label={open ? "Închide meniul" : "Deschide meniul"}
                        data-testid="header-menu-toggle"
                        className="lg:hidden p-2 -mr-2 text-[#0d3d2e]"
                    >
                        {open ? <X className="h-6 w-6" strokeWidth={1.5} /> : <Menu className="h-6 w-6" strokeWidth={1.5} />}
                    </button>
                </div>
            </div>

            {/* Mobile menu panel */}
            {open && (
                <div
                    data-testid="mobile-menu"
                    className="lg:hidden border-t border-[#0d3d2e]/10 bg-[#fcfbf8] shadow-lg"
                >
                    <nav className="px-6 py-5 flex flex-col gap-1">
                        {NAV_LINKS.map((l) => (
                            <a
                                key={l.href}
                                href={l.href}
                                onClick={() => setOpen(false)}
                                data-testid={`m-${l.testid}`}
                                className="block py-3 px-2 text-base font-semibold text-[#0d3d2e] border-b border-[#0d3d2e]/10 last:border-b-0 hover:bg-[#0d3d2e]/5 rounded transition-colors"
                            >
                                {l.label}
                            </a>
                        ))}
                        <div className="flex flex-col gap-2 mt-5">
                            <a
                                href="tel:0745643348"
                                className="inline-flex items-center justify-center gap-2 rounded-full border border-[#0d3d2e]/25 text-[#0d3d2e] py-3 text-sm font-medium"
                                data-testid="m-call-btn"
                            >
                                <Phone className="h-4 w-4" strokeWidth={1.5} />
                                Sună 0745 643 348
                            </a>
                            <button
                                onClick={handleCta}
                                data-testid="m-cta-btn"
                                className="inline-flex items-center justify-center rounded-full bg-[#0d3d2e] text-[#fcfbf8] py-3 text-sm font-medium"
                            >
                                Cere ofertă gratuită
                            </button>
                        </div>
                    </nav>
                </div>
            )}
        </header>
    );
}
